
export const types = {
    uiSetError: "[UI] Set Error",
    uiRemoveError: "[UI] Remove Error",
    uiStartLoading: "[UI] Start Loading",
    uiFinishLoading: "[UI] Finish Loading",
}